<template>
  <div v-if="shouldRenderConfig" :class="[getClassName, getDisabledClass]">
    <button
      type="button"
      class="btn btn-primary"
      :class="activeClass()"
      @click="onClickSelectPageOption(code)"
    >
      <div :class="getClassName + 'Index'">
        {{ index + 1 }}
      </div>
      <div :class="getClassName + 'Label'">
        {{ name }}
      </div>
      <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
      <appAwesomeIcon
        v-if="getIsShowCheckedPageOptionFlag && checked"
        icon="check"
        useClass="pageOptionCheck"
      />
    </button>

    <div v-if="getPageAttributesInPageOptions">
      <appPageOptionAttributesContainer
        :code="code"
      ></appPageOptionAttributesContainer>
    </div>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { useTooltipsStore } from "@/stores/modules/tooltips";
import { useCheckedPageOptionsStore } from "@/stores/modules/checkedPageOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, ["getPageAttributesInPageOptions"]),
    ...mapState(useWebproductStore, ["getActivePageOptionsForPP"]),
    ...mapState(useTooltipsStore, ["getShowTooltipsInPOHeader"]),
    ...mapState(useCheckedPageOptionsStore, [
      "getChecked",
      "getCheckedIsNext",
      "getIsShowCheckedPageOptionFlag",
      "getIsCheckedPageOptionActive"
    ]),
    name: function () {
      return this.propsData.label;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOHeader && this.propsData.tooltip;
    },
    checked: function () {
      return this.getChecked(this.index);
    },
    getDisabledClass: function () {
      if (!this.getIsCheckedPageOptionActive) {
        return "";
      }
      return this.checked || this.getCheckedIsNext(this.index)
        ? ""
        : "disabled";
    }
  },

  methods: {
    ...mapActions(useWebproductStore, ["setActiveProductPageOption"]),
    onClickSelectPageOption(option) {
      this.setActiveProductPageOption({ ppcode: this.ppcode, option });
    },
    activeClass: function () {
      return this.getActivePageOptionsForPP(this.ppcode) == this.code
        ? "active"
        : "";
    }
  },
  props: ["propsData", "index", "code", "ppcode"]
};
</script>
